export const useJobsStore = defineStore('jobs', {
  state: () => ({
    jobs: [],
    currentPage: 1,
    totalPages: 1,
    perPage: 20,
  }),
  actions: {
    setJobs(jobs) {
      this.jobs = [...this.jobs, ...jobs.data];
      this.currentPage = Number(jobs.meta.pagination.current_page);
      this.totalPages = Number(jobs.meta.pagination.last_page);
    },
    resetJobs() {
      this.jobs = [];
      this.currentPage = 1;
      this.totalPages = 1;
    },
    incrementCurrentPage() {
      if (this.currentPage >= this.totalPages) {
        return;
      }
      this.currentPage += 1;
    },
  },
  getters: {
    paginationParams: (state) => ({
      page: state.currentPage,
      perPage: state.perPage,
    }),
    hasMoreJobs: (state) => state.currentPage < state.totalPages,
  },
});
